import { AnalyticsBrowser } from '@segment/analytics-next';

export const analytics = AnalyticsBrowser.load(
  {
    writeKey: process.env.NEXT_PUBLIC_BANZAI_SEGMENT_WRITE_KEY!,
  },
  {
    integrations: {
      All: true,
    },
  }
);
